import React, { Component } from 'react';
import LimiteCompraItem from './LimiteCompraItem';

class LimiteCompra extends Component {
    constructor(props){
        super(props)
        this.state={
            limiteCompra:""
        }
    }
 format(valor){
     var num = String(valor).replace(/\./g,'').split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
         num = num.split('').reverse().join('').replace(/^[\.]/,'');
        return num
}
    render() {
        let data = this.props.data;
        let purchaseLimitsNodes = null;

        if (data) {
            purchaseLimitsNodes = data.map((limiteCompraItem) => {
                let limiteValor= this.format(limiteCompraItem.Valor) 
                const codigoValor =  limiteCompraItem.Codigo+ (limiteCompraItem.MonedaId == 1 ? " - $ " : " - u$s ") +limiteValor   
                return <LimiteCompraItem
                    key={limiteCompraItem.Id}
                    id={limiteCompraItem.Id}
                    descripcion={limiteCompraItem.Descripcion}
                    codigoValor={codigoValor}
                    valor={limiteCompraItem.Valor}
                    checked={limiteCompraItem.Checked}
                    checkItem={this.props.checkItem}
                    checkThisAndAllNext={this.props.checkThisAndAllNext}
                />
            })
        }
        return (
            data != undefined &&
            <div className="row top-separator-xs vertical-scrollable-container-md">
                <div className="col-md-12">
                    {purchaseLimitsNodes}                    
                </div>
            </div>
        );
    }
};

export default LimiteCompra;